import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { dedupedRequest } from '../../utils/axios';


const TopicsPanel = () => {
  const { token } = useAuth();
  const [topics, setTopics] = useState<any[]>([]);
  const [formData, setFormData] = useState({
    name: '',
  });

  const loadTopics = async () => {
    // console.log('Doing loadClusters');
    dedupedRequest({ method: 'GET', url: '/admin/topics' }, { useCache: false })
      .then(res => setTopics(res.data))
      .catch(err => console.error("Failed to load topics", err));
  };
  
  useEffect(() => {
    loadTopics();
  }, [token, topics.length]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    fetch('/api/admin/topics', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
    .then(newTopic => {
      setTopics([...topics, newTopic]);
      setFormData({ name: ''});
    });
  };

  return (
    <>
      <h5>Themen</h5>
      <Table striped bordered size="sm">
        <thead>
          <tr>
            <th>ID</th><th>Name</th>
          </tr>
        </thead>
        <tbody>
          {topics.map(c => (
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>{c.name}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <h5>Neues Thema</h5>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Themenname"
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </Col>
        </Row>
        <Button type="submit">Thema speichern</Button>
      </Form>
    </>
  );
};

export default TopicsPanel;
